import { render, staticRenderFns } from "./ticket-app-title-bar.vue?vue&type=template&id=1d74c4fe"
import script from "./ticket-app-title-bar.vue?vue&type=script&setup=true&lang=ts"
export * from "./ticket-app-title-bar.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports